export default __webpack_public_path__ + "static/gulchak-c7427ef07ca0bf3a2659089bfa4c13f7.jpg";